import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  text-decoration: underline;
`;

const Term = ({ text, definition, link }) => <Container>{text}</Container>;

export default Term;
